"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPortalCurrencyInfo = exports.FetchPortalCurrencyInfo = exports.FetchPortalCurrencyInfoActionTypes = exports.syncROISetting = exports.SyncROISetting = exports.SyncROISettingActionTypes = exports.syncCostPerLead = exports.SyncCostPerLead = exports.SyncCostPerLeadActionTypes = exports.fetchCostPerLead = exports.FetchCostPerLead = exports.FetchCostPerLeadActionTypes = exports.AdsROIActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _fluxActions = require("flux-actions");

var AdsROIActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_COST_PER_LEAD: null,
  SYNC_COST_PER_LEAD: null,
  SYNC_ROI_SETTING: null,
  FETCH_PORTAL_CURRENCY_INFO: null
}, 'ads');
exports.AdsROIActionTypes = AdsROIActionTypes;
var FetchCostPerLeadActionTypes = (0, _actions.createRequestTypes)(AdsROIActionTypes.FETCH_COST_PER_LEAD);
exports.FetchCostPerLeadActionTypes = FetchCostPerLeadActionTypes;
var FetchCostPerLead = (0, _actions.createRequestActions)(FetchCostPerLeadActionTypes);
exports.FetchCostPerLead = FetchCostPerLead;
var fetchCostPerLead = (0, _fluxActions.createAction)(AdsROIActionTypes.FETCH_COST_PER_LEAD);
exports.fetchCostPerLead = fetchCostPerLead;
var SyncCostPerLeadActionTypes = (0, _actions.createRequestTypes)(AdsROIActionTypes.SYNC_COST_PER_LEAD);
exports.SyncCostPerLeadActionTypes = SyncCostPerLeadActionTypes;
var SyncCostPerLead = (0, _actions.createRequestActions)(SyncCostPerLeadActionTypes);
exports.SyncCostPerLead = SyncCostPerLead;
var syncCostPerLead = (0, _fluxActions.createAction)(AdsROIActionTypes.SYNC_COST_PER_LEAD, function (costPerLead) {
  return costPerLead;
});
exports.syncCostPerLead = syncCostPerLead;
var SyncROISettingActionTypes = (0, _actions.createRequestTypes)(AdsROIActionTypes.SYNC_ROI_SETTING);
exports.SyncROISettingActionTypes = SyncROISettingActionTypes;
var SyncROISetting = (0, _actions.createRequestActions)(SyncROISettingActionTypes);
exports.SyncROISetting = SyncROISetting;
var syncROISetting = (0, _fluxActions.createAction)(AdsROIActionTypes.SYNC_ROI_SETTING, function (roiType) {
  return roiType;
});
exports.syncROISetting = syncROISetting;
var FetchPortalCurrencyInfoActionTypes = (0, _actions.createRequestTypes)(AdsROIActionTypes.FETCH_PORTAL_CURRENCY_INFO);
exports.FetchPortalCurrencyInfoActionTypes = FetchPortalCurrencyInfoActionTypes;
var FetchPortalCurrencyInfo = (0, _actions.createRequestActions)(FetchPortalCurrencyInfoActionTypes);
exports.FetchPortalCurrencyInfo = FetchPortalCurrencyInfo;
var fetchPortalCurrencyInfo = (0, _fluxActions.createAction)(AdsROIActionTypes.FETCH_PORTAL_CURRENCY_INFO);
exports.fetchPortalCurrencyInfo = fetchPortalCurrencyInfo;